import {
  CLEAN_VALIDATION_FLAGS,
  CLEAR_ERROR,
  CREATE_CLOUD_CREDENTIAL,
  CREATE_CLOUD_CREDENTIAL_IS_ERROR,
  CREATE_CLOUD_CREDENTIAL_IS_PENDING,
  FETCH_CLOUD_CREDENTIALS,
  FETCH_CLOUD_CREDENTIALS_ERROR,
  FETCH_CLOUD_CREDENTIALS_PENDING,
  FORCE_REDUCER,
  REMOVE_CLOUD_CREDENTIAL,
  REMOVE_CLOUD_CREDENTIAL_IS_ERROR,
  REMOVE_CLOUD_CREDENTIAL_IS_PENDING,
  SWITCH_CLOUD_CREDENTIAL,
  SWITCH_CLOUD_CREDENTIAL_IS_ERROR,
  SWITCH_CLOUD_CREDENTIAL_IS_PENDING,
  UPDATE_CLOUD_CREDENTIAL,
  UPDATE_CLOUD_CREDENTIAL_IS_ERROR,
  UPDATE_CLOUD_CREDENTIAL_IS_PENDING,
  VALIDATE_CLOUD_CREDENTIALS_IS_COMPLETE,
  VALIDATE_CLOUD_CREDENTIALS_IS_ERROR,
  VALIDATE_CLOUD_CREDENTIALS_IS_PENDING,
} from 'services/GameHosting/CloudCredentials/types';
import * as apiActionTypes from 'utils/apiActionTypes';

const cloudCredentialsReducer = (
  state = {
    cloudCredentials: [],
    fetchIsComplete: false,
    fetchIsPending: false,
    fetchIsError: null,
    validationIsError: null,
    validationIsPending: false,
    validationIsComplete: false,
    creationIsComplete: false,
    creationIsPending: false,
    creationIsError: null,
    editIsComplete: false,
    editIsPending: false,
    editIsError: null,
    switchIsComplete: false,
    switchIsPending: false,
    switchIsError: null,
    deleteIsComplete: false,
    deleteIsPending: false,
    deleteIsError: null,
  },
  action: $TSFixMe = undefined,
) => {
  const newState = { ...state };
  let credentialIndex = 0;
  let credentialStatusIndex = 0;

  switch (action.type) {
    case FETCH_CLOUD_CREDENTIALS:
      return {
        ...state,
        cloudCredentials: action.cloudCredentials,
        fetchIsComplete: true,
        fetchIsPending: false,
        fetchIsError: null,
      };
    case FETCH_CLOUD_CREDENTIALS_PENDING:
      return {
        ...state,
        fetchIsComplete: false,
        fetchIsPending: true,
        fetchIsError: null,
      };
    case FETCH_CLOUD_CREDENTIALS_ERROR:
      return {
        ...state,
        fetchIsComplete: true,
        fetchIsPending: false,
        fetchIsError: action.error,
      };
    case CREATE_CLOUD_CREDENTIAL:
      credentialStatusIndex = state.cloudCredentials.findIndex(
        (credential) => (credential as $TSFixMe).status === 1 && (credential as $TSFixMe).providerId === action.cloudCredential.providerId,
      );

      return {
        ...state,
        cloudCredentials:
          action.cloudCredential.status === 1
            ? state.cloudCredentials
                .map((credential, index) => {
                  if (index !== credentialStatusIndex) {
                    return credential;
                  }

                  return {
                    // @ts-expect-error ts-migrate(2698) FIXME: Spread types may only be created from object types... Remove this comment to see the full error message
                    ...credential,
                    status: 0,
                  };
                })
                .concat(action.cloudCredential)
            : state.cloudCredentials.concat(action.cloudCredential),
        creationIsComplete: true,
        creationIsPending: false,
        creationIsError: null,
      };
    case CREATE_CLOUD_CREDENTIAL_IS_PENDING:
      return {
        ...state,
        creationIsComplete: false,
        creationIsPending: true,
        creationIsError: null,
      };
    case CREATE_CLOUD_CREDENTIAL_IS_ERROR:
      return {
        ...state,
        creationIsComplete: true,
        creationIsPending: false,
        creationIsError: action.error,
      };

    case UPDATE_CLOUD_CREDENTIAL:
      credentialIndex = state.cloudCredentials.findIndex((credential) => (credential as $TSFixMe).name === action.credentialName);

      credentialStatusIndex = state.cloudCredentials.findIndex(
        (credential) => (credential as $TSFixMe).status === 1 && (credential as $TSFixMe).providerId === action.cloudCredential.providerId,
      );

      return {
        ...state,
        editIsComplete: true,
        editIsPending: false,
        editIsError: null,
        cloudCredentials:
          action.cloudCredential.status === 1
            ? state.cloudCredentials
                .map((credential, index) => {
                  if (index !== credentialStatusIndex) {
                    return credential;
                  }

                  return {
                    // @ts-expect-error ts-migrate(2698) FIXME: Spread types may only be created from object types... Remove this comment to see the full error message
                    ...credential,
                    status: 0,
                  };
                })
                .map((credential, index) => {
                  if (index !== credentialIndex) {
                    return credential;
                  }

                  return {
                    ...credential,
                    ...action.cloudCredential,
                  };
                })
            : state.cloudCredentials.map((credential, index) => {
                if (index !== credentialIndex) {
                  return credential;
                }

                return {
                  // @ts-expect-error ts-migrate(2698) FIXME: Spread types may only be created from object types... Remove this comment to see the full error message
                  ...credential,
                  ...action.cloudCredential,
                };
              }),
      };
    case UPDATE_CLOUD_CREDENTIAL_IS_PENDING:
      return {
        ...state,
        editIsComplete: false,
        editIsPending: true,
        editIsError: null,
      };
    case UPDATE_CLOUD_CREDENTIAL_IS_ERROR:
      return {
        ...state,
        editIsComplete: true,
        editIsPending: false,
        editIsError: action.error,
      };

    case SWITCH_CLOUD_CREDENTIAL:
      credentialIndex = state.cloudCredentials.findIndex((credential) => (credential as $TSFixMe).name === action.credentialName);

      credentialStatusIndex = state.cloudCredentials.findIndex(
        (credential) => (credential as $TSFixMe).status === 1 && (credential as $TSFixMe).providerId === action.cloudCredential.providerId,
      );

      return {
        ...state,
        switchIsComplete: true,
        switchIsPending: false,
        switchIsError: null,
        cloudCredentials:
          action.cloudCredential.status === 1
            ? state.cloudCredentials
                .map((credential, index) => {
                  if (index !== credentialStatusIndex) {
                    return credential;
                  }

                  return {
                    // @ts-expect-error ts-migrate(2698) FIXME: Spread types may only be created from object types... Remove this comment to see the full error message
                    ...credential,
                    status: 0,
                  };
                })
                .map((credential, index) => {
                  if (index !== credentialIndex) {
                    return credential;
                  }

                  return {
                    ...credential,
                    ...action.cloudCredential,
                  };
                })
            : state.cloudCredentials.map((credential, index) => {
                if (index !== credentialIndex) {
                  return credential;
                }

                return {
                  // @ts-expect-error ts-migrate(2698) FIXME: Spread types may only be created from object types... Remove this comment to see the full error message
                  ...credential,
                  ...action.cloudCredential,
                };
              }),
      };
    case SWITCH_CLOUD_CREDENTIAL_IS_PENDING:
      return {
        ...state,
        switchIsComplete: false,
        switchIsPending: true,
        switchIsError: null,
      };
    case SWITCH_CLOUD_CREDENTIAL_IS_ERROR:
      return {
        ...state,
        switchIsComplete: true,
        switchIsPending: false,
        switchIsError: action.error,
      };

    case REMOVE_CLOUD_CREDENTIAL:
      newState.cloudCredentials = newState.cloudCredentials.filter((e) => (e as $TSFixMe).name !== action.credentialName);

      return {
        ...newState,
        deleteIsComplete: true,
        deleteIsPending: false,
        deleteIsError: null,
      };
    case REMOVE_CLOUD_CREDENTIAL_IS_PENDING:
      return {
        ...state,
        deleteIsComplete: false,
        deleteIsPending: true,
        deleteIsError: null,
      };
    case REMOVE_CLOUD_CREDENTIAL_IS_ERROR:
      return {
        ...state,
        deleteIsComplete: true,
        deleteIsPending: false,
        deleteIsError: action.error,
      };
    case VALIDATE_CLOUD_CREDENTIALS_IS_COMPLETE:
      return {
        ...state,
        validationIsComplete: true,
        validationIsPending: false,
        validationIsError: null,
      };
    case VALIDATE_CLOUD_CREDENTIALS_IS_PENDING:
      return {
        ...state,
        validationIsPending: action.pending,
        validationIsComplete: false,
        validationIsError: null,
      };
    case VALIDATE_CLOUD_CREDENTIALS_IS_ERROR:
      return {
        ...state,
        validationIsError: action.error,
        validationIsPending: false,
        validationIsComplete: true,
      };
    case CLEAN_VALIDATION_FLAGS:
      return {
        ...state,
        validationIsPending: false,
        validationIsComplete: false,
      };
    case CLEAR_ERROR:
      return {
        ...state,
        validationIsPending: false,
        validationIsComplete: false,
        validationIsError: null,
      };
    case FORCE_REDUCER:
      return {
        ...state,
        [action.property]: action.value,
      };
    case 'RESET_CLOUD_CREDENTIAL_REDUCER':
    case 'RESET_REDUCER':
      return {
        ...state,
        fetchIsComplete: false,
        fetchIsPending: false,
        fetchIsError: null,
        validationError: null,
        validationPending: false,
        validationComplete: false,
        creationIsComplete: false,
        creationIsPending: false,
        creationIsError: null,
      };
    case apiActionTypes.ACTION_PENDING:
      return { ...state, isPending: action.isPending };
    case apiActionTypes.ACTION_COMPLETE:
      return { ...state };
    case apiActionTypes.ACTION_ERROR:
      return { ...state, error: action.isError };
    default:
      return state;
  }
};

export default cloudCredentialsReducer;
